// import logo from './logo.svg';
// import './App.css';

// function App() {
//   return (
//     <div className="App">
//       <header className="App-header">
//         <img src={logo} className="App-logo" alt="logo" />
//         <p>
//           Edit <code>src/App.js</code> and save to reload.
//         </p>
//         <a
//           className="App-link"
//           href="https://reactjs.org"
//           target="_blank"
//           rel="noopener noreferrer"
//         >
//           Learn React
//         </a>
//       </header>
//     </div>
//   );
// }

// export default App;




// src/App.js
import React from 'react';
import { BrowserRouter as Router, Route, Routes } from 'react-router-dom';
import HomePage from './pages/HomePage';  // Import the HomePage component
import Hero from './pages/Hero';
import About from './pages/About';
import Footer from './pages/Footer';
// import './index.css';


function App() {
  return (
    <Router>
      <Routes>
        <Route path="/" element={<HomePage />} />  {/* Route for the HomePage */}
        {/* Add more routes as your app grows */}
        <Route path='/features' element={<Hero/>} />
        <Route path='/working' element={<About/>} />
        <Route path='/download' element={<Footer/>} />

      </Routes>
    </Router>
  );
}

export default App;

